import { forwardRef } from 'preact/compat'
import { useTranslation } from 'react-i18next'

type Props = {
	label?: string
	units?: 'hours' | 'minutes' | 'meters' | 'km' | 'inches' | 'kg' | 'dollars' | 'celsius'
	integer?: boolean
	decimal?: boolean
} & JSX.HTMLAttributes<HTMLInputElement>

const Input = forwardRef<HTMLInputElement, Props>(
	({ label, children, units, integer, decimal, className: className, ...p }, ref) => {
		const { t } = useTranslation('forms')
		const handleFocus = (event: FocusEvent) => {
			event?.target?.select()
		}

		return (
			<label className={className}>
				{label}
				<span className='lowercase text-gray-400'>{units && ` (${t(units)})`}</span>
				{p.required && <span class='text-red-600'>&nbsp;*</span>}
				<input
					type='text'
					ref={ref}
					{...(integer && INT)}
					{...(decimal && DECIMAL)}
					{...(units && UNITS[units])}
					{...p}
					onFocus={handleFocus}
				/>
				{children}
			</label>
		)
	}
)
export default Input

const INT = { type: 'number', inputMode: 'numeric', min: 0 }
const DECIMAL = { type: 'number', inputMode: 'decimal', min: 0, step: 'any' }
const UNITS = {
	minutes: { ...INT },
	hours: { ...DECIMAL },
	meters: { ...DECIMAL },
	km: { ...DECIMAL },
	inches: { ...DECIMAL },
	kg: { ...DECIMAL },
	dollars: { ...DECIMAL },
	celsius: {},
}
